function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import merge from "lodash/merge";
import * as ActionTypes from "../../actions";
import { memberStates } from "../../constants";

// Updates an entity cache in response to any action with response.entities.
var goalMemberEntities = function goalMemberEntities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    byId: {},
    byGoalId: {},
    byGoalIdAndUserId: {},
    byUserIdAndConfirmedAtIsNull: {},
    byUserIdAndStateInAndConfirmedAtNotNull: {},
    byUserIdAndConfirmedAtNotNull: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.LOGIN_SUCCESS:
    case ActionTypes.GET_AUTHENTICATION_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      var key = action.response.userId;
      var listItemArr = action.response.notificationListItemsByUserId[key];
      if (listItemArr) listItemArr.forEach(function (listItem) {
        return merge(byId, listItem.memberById);
      });
      var listItemArr = action.response.notificationListItemsByUserIdAndViewedAtIsNull[key];
      if (listItemArr) listItemArr.forEach(function (listItem) {
        return merge(byId, listItem.memberById);
      });
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.GET_NOTIFICATIONTOASTSBYUSERID_SUCCESS:
    case ActionTypes.GET_NOTIFICATIONTOASTSBYUSERIDANDVIEWEDATISNULL_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      action.response.forEach(function (notificationListItem) {
        return merge(byId, notificationListItem.memberById);
      });
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.GET_EVENTLISTITEMSBYUSERIDANDEVENTTYPEIDIN_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      action.response.forEach(function (eventListItem) {
        return merge(byId, eventListItem.memberById);
      });
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.GET_GOALMEMBERSVIEWBYUSERID_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      var nonFinalizedMemberStates = [memberStates.DELETABLE, memberStates.ONGOING, memberStates.PENDING_FINALIZE].join(",");
      var key = [action.userId, nonFinalizedMemberStates].join("-");
      action.response.memberListItemsByMemberUserIdAndMemberStateIn[key].forEach(function (memberListItem) {
        return merge(byId, memberListItem.memberById);
      });
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.GET_GOALMEMBERLISTITEMSBYMEMBERUSERIDANDMEMBERSTATES_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      action.response.forEach(function (memberListItem) {
        return merge(byId, memberListItem.memberById);
      });
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.GET_GOALVIEWBYGOALIDANDAUTHUSERID_SUCCESS:
      var byGoalIdAndUserId = action.response.memberByGoalIdAndUserId;
      return merge({}, state, {
        byGoalIdAndUserId: byGoalIdAndUserId
      });
    case ActionTypes.GET_GOALMEMBERSBYUSERIDANDSTATEINANDCONFIRMEDATISNOTNULL_SUCCESS:
      if (!action.response._embedded) return state;
      var byUserIdAndStateInAndConfirmedAtNotNull = {};
      var key = [action.userId, action.states].join("-");
      byUserIdAndStateInAndConfirmedAtNotNull[key] = action.response._embedded.goalMembers;
      return merge({}, state, {
        byUserIdAndStateInAndConfirmedAtNotNull: byUserIdAndStateInAndConfirmedAtNotNull
      });
    case ActionTypes.GET_GOALMEMBERSBYUSERIDANDCONFIRMEDATISNOTNULL_SUCCESS:
      if (!action.response._embedded) return state;
      var byUserIdAndConfirmedAtNotNull = {};
      byUserIdAndConfirmedAtNotNull[action.userId] = action.response._embedded.goalMembers;
      return merge({}, state, {
        byUserIdAndConfirmedAtNotNull: byUserIdAndConfirmedAtNotNull
      });
    case ActionTypes.GET_NOTIFICATIONTABBYUSERID_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      action.response.notificationListItemsByUserId[action.userId].forEach(function (listItem) {
        return merge(byId, listItem.memberById);
      });
      var byUserIdAndConfirmedAtIsNull = action.response.goalMembersByUserIdAndConfirmedAtIsNull;
      return Object.assign({}, state, {
        byId: byId,
        byUserIdAndConfirmedAtIsNull: byUserIdAndConfirmedAtIsNull
      });
    case ActionTypes.POST_GOALMEMBER_SUCCESS:
      var byUserIdAndConfirmedAtIsNull = _objectSpread({}, state.byUserIdAndConfirmedAtIsNull);
      var byGoalIdAndUserId = _objectSpread({}, state.byGoalIdAndUserId);
      var embedded = action.response._embedded;
      var key = action.goalMember.user.id;
      if (byUserIdAndConfirmedAtIsNull[key]) byUserIdAndConfirmedAtIsNull[key] = byUserIdAndConfirmedAtIsNull[key].map(function (member) {
        return member.id === action.goalMember.id ? embedded : member;
      }).filter(function (member) {
        return member.id !== action.goalMember.id || !embedded.confirmedAt;
      });
      if (action.goalMember.goalId) {
        var key = [action.goalMember.goalId, action.goalMember.user.id].join("-");
        byGoalIdAndUserId[key] = embedded;
      }
      return Object.assign({}, state, {
        byUserIdAndConfirmedAtIsNull: byUserIdAndConfirmedAtIsNull,
        byGoalIdAndUserId: byGoalIdAndUserId
      });
    case ActionTypes.POST_GOALMEMBEREXCLUSIONPREFERENCES_SUCCESS:
      var byGoalIdAndUserId = _objectSpread({}, state.byGoalIdAndUserId);
      var key = [action.goalMember.user.id, action.goalMember.goal.id].join("-");
      var member = byGoalIdAndUserId[key];
      if (member) {
        var member = _objectSpread({}, member);
        member.exclusionPreferences = action.response._embedded;
        byGoalIdAndUserId[key] = member;
      }
      return Object.assign({}, state, {
        byGoalIdAndUserId: byGoalIdAndUserId
      });
    case ActionTypes.GET_GOALMEMBERBYGOALIDANDUSERID_SUCCESS:
      var byGoalIdAndUserId = _objectSpread({}, state.byGoalIdAndUserId);
      var key = [action.goalId, action.userId].join("-");
      byGoalIdAndUserId[key] = action.response;
      return Object.assign({}, state, {
        byGoalIdAndUserId: byGoalIdAndUserId
      });
    case ActionTypes.POST_GOALMEMBERS_SUCCESS:
      var byGoalId = {};
      byGoalId[action.goal.id] = action.response._embedded;
      return Object.assign({}, state, {
        byGoalId: byGoalId
      });
    case ActionTypes.DELETE_GOALMEMBER_SUCCESS:
      if (!action.response.success) return state;
      var byUserIdAndConfirmedAtIsNull = _objectSpread({}, state.byUserIdAndConfirmedAtIsNull);
      var byGoalIdAndUserId = _objectSpread({}, state.byGoalIdAndUserId);
      var userId = action.goalMember.user.id;
      if (byUserIdAndConfirmedAtIsNull[userId]) byUserIdAndConfirmedAtIsNull[userId] = byUserIdAndConfirmedAtIsNull[userId].filter(function (member) {
        return member.id !== action.goalMember.id;
      });
      var key = [action.goalMember.goal.id, action.goalMember.user.id].join("-");
      if (byGoalIdAndUserId[key]) delete byGoalIdAndUserId[key];
      return Object.assign({}, state, {
        byUserIdAndConfirmedAtIsNull: byUserIdAndConfirmedAtIsNull,
        byGoalIdAndUserId: byGoalIdAndUserId
      });
    case ActionTypes.GET_OPERATIONFORMBYINVESTMENTITEMIDANDUSERID_SUCCESS:
      var byUserIdAndStateInAndConfirmedAtNotNull = _objectSpread({}, state.byUserIdAndStateInAndConfirmedAtNotNull);
      merge(byUserIdAndStateInAndConfirmedAtNotNull, action.response.membersByUserIdAndStateInAndConfirmedAtNotNull);
      return Object.assign({}, state, {
        byUserIdAndStateInAndConfirmedAtNotNull: byUserIdAndStateInAndConfirmedAtNotNull
      });
    case ActionTypes.GET_GOALMEMBERSTABBYGOALID_SUCCESS:
      var byGoalId = _objectSpread({}, state.byGoalId);
      byGoalId[action.goalId] = action.response.membersByGoalId[action.goalId];
      return Object.assign({}, state, {
        byGoalId: byGoalId
      });
    default:
      return state;
  }
};
export default goalMemberEntities;